import { motion } from 'framer-motion';
import { FeatureProps } from '../types';
import { fadeInUp } from '../utils/animations';

const Feature = ({ title, description, icon }: FeatureProps) => {
  return (
    <motion.div 
      className="flex flex-col items-center text-center p-6 border border-slate-800 rounded-lg bg-slate-800/30 backdrop-blur-sm"
      variants={fadeInUp}
    >
      {icon && (
        <div className="flex items-center justify-center h-16 w-16 rounded-full bg-purple-700 mb-4">
          {icon}
        </div>
      )}
      <h3 className="text-xl font-semibold text-white mb-3">{title}</h3>
      <p className="text-slate-300">{description}</p>
    </motion.div>
  );
};

export default Feature;
